export const PhoneMessages = {
  labels: {
    default: {
      id: 'phone.Label.Default',
      defaultMessage: 'Phone',
    },
    fax: {
      id: 'phone.Label.Fax',
      defaultMessage: 'Fax',
    },
    cell: {
      id: 'phone.Label.Cell',
      defaultMessage: 'Cell',
    },
    work: {
      id: 'phone.Label.Work',
      defaultMessage: 'Work',
    },
    home: {
      id: 'phone.Label.Home',
      defaultMessage: 'Home',
    },
  },
};
